(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/pix-item/assets/javascripts/pix-item.js') >= 0) return;  svs.modules.push('/components/tipsen/pix-item/assets/javascripts/pix-item.js');
"use strict";


const {
  useCallback,
  useEffect,
  useRef,
  useState
} = React;
const {
  useBranding,
  useIsDrawPlayable
} = svs.components.tipsen.hooks;
const {
  usePlaceBet
} = svs.components.sport.quickplayModal.placeBet;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_LG
} = svs.components.lbUtils.useMediaQuery;
const {
  Shield
} = svs.components.lbUi.shield;
const {
  analytics
} = svs.components;
const {
  products
} = svs.utils;
const {
  QuickplayModal
} = svs.components.sport.quickplayModal;
const {
  resolveCompetitionYear
} = svs.components.marketplaceCompetition.helpers;
const {
  CompetitionType
} = svs.components.marketplaceCompetition.constants;
const {
  getProductBrandByDraw
} = svs.components.lbUtils.brandMapping.fn;
const FirstBannerText = () => React.createElement(React.Fragment, null, React.createElement("span", {
  className: "f-bold"
}, "PIX! "), React.createElement("span", {
  className: "f-normal"
}, "F\xE4rdiga spel."));
const SecondBannerText = () => {
  const isWideDevice = useMediaQuery(breakpoints.up(BREAKPOINT_LG));
  if (isWideDevice) {
    return React.createElement(React.Fragment, null, "\xA0", React.createElement("span", {
      className: "f-normal"
    }, "Helt enkelt."));
  }
  return React.createElement("span", {
    className: "f-normal block"
  }, "Helt enkelt.");
};
const BuyBannerText = () => React.createElement("p", null, React.createElement(FirstBannerText, null), React.createElement(SecondBannerText, null));
const PayButton = _ref => {
  var _svs$core$config$data;
  let {
    isDisabled,
    drawNumber,
    payButtonClassNames,
    productId,
    systemCost,
    wallet,
    rowPrice,
    branding
  } = _ref;
  const isSelfService = ((_svs$core$config$data = svs.core.config.data.svsconfig) === null || _svs$core$config$data === void 0 ? void 0 : _svs$core$config$data.isSelfService) || false;
  const {
    placeBet
  } = usePlaceBet();
  const handlePayButtonClick = useCallback(async event => {
    if (!isDisabled) {
      event.stopPropagation();
      const {
        drawResponse
      } = await svs.components.sport.quickplayModal.services.fetchDrawAndPix({
        productId,
        drawNumber,
        systemCost,
        rowPrice,
        branding,
        isPixMix: false
      });
      placeBet({
        productId,
        drawData: drawResponse,
        wallet,
        isPixMix: false
      });
    }
  }, [isDisabled, productId, placeBet, wallet, systemCost, rowPrice, branding, drawNumber]);
  const handlePayButtonKeyDown = useCallback((event, key) => {
    event.stopPropagation();
    if ((key === null || key === void 0 ? void 0 : key.code) === 'Enter' || (key === null || key === void 0 ? void 0 : key.code) === 'Space') {
      handlePayButtonClick(event);
    }
  }, [handlePayButtonClick]);
  return React.createElement("button", {
    className: payButtonClassNames,
    "data-testid": "tipsen-pix-item-pay-button",
    disabled: isDisabled,
    onClick: handlePayButtonClick,
    onKeyDown: handlePayButtonKeyDown,
    type: "button"
  }, isSelfService ? 'Lägg i varukorg' : 'Köp');
};
const PixItem = _ref2 => {
  let {
    draw,
    competitionBranding,
    drawNumber,
    index,
    isCompetition,
    productId,
    systemCost,
    wallet,
    competitionType,
    rowPrice
  } = _ref2;
  const isDrawPlayable = useIsDrawPlayable(productId, drawNumber);
  const disablePixItem = !isDrawPlayable;
  const pixItemClassNames = ['pg_pix'];
  const showDetailsClassNames = ['pg_pix__buy_banner__details'];
  const pixItemRef = useRef();
  const initiator = useRef();
  const brandingList = useBranding();
  const brandingByDraw = getProductBrandByDraw(draw);
  const branding = brandingByDraw || brandingList[brandingList.length - 1] || brandingList[0] || 'sport';
  pixItemClassNames.push("pg_pix--".concat(branding));
  if (disablePixItem) {
    pixItemClassNames.push('pg_pix--disabled');
    showDetailsClassNames.push('pg_pix__buy_banner__details--disabled');
  } else {
    pixItemClassNames.push('elevation-100', 'clickable-magnetic');
  }
  const [showQuickPlay, setShowQuickPlay] = useState(false);
  const handleClick = useCallback(() => {
    if (!disablePixItem) {
      const productName = products.getProductClassName(productId);
      analytics.trackEvent({
        category: 'Widget banner',
        action: 'Details',
        opt_label: "".concat(productName, "-").concat(systemCost)
      });
      setShowQuickPlay(true);
    }
  }, [disablePixItem, productId, systemCost]);
  const handleKeyDown = useCallback(key => {
    if ((key === null || key === void 0 ? void 0 : key.code) === 'Enter' || (key === null || key === void 0 ? void 0 : key.code) === 'Space') {
      handleClick();
    }
  }, [handleClick]);
  const onModalClose = useCallback(() => {
    setShowQuickPlay(false);
  }, []);
  useEffect(() => {
    const element = pixItemRef.current;
    element.addEventListener('tipsenOpenPixModal', handleClick);
    return () => element.removeEventListener('tipsenOpenPixModal', handleClick);
  }, [handleClick]);
  return React.createElement(React.Fragment, null, React.createElement("div", {
    "aria-labelledby": "pg-pix__item_".concat(index),
    className: pixItemClassNames.join(' '),
    "data-pix-amount": systemCost,
    id: "pg-pix__item_".concat(index),
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    ref: pixItemRef,
    role: "group"
  }, React.createElement("div", {
    className: "pg_pix__details_banner"
  }, React.createElement("div", {
    className: "pg_pix__details_banner__splash"
  }), isCompetition ? React.createElement(Shield, {
    className: "shield-pix shield-large pg_pix__details_banner__shield ".concat(competitionType === 'TipsEM' ? 'shield-green-white shield-green-white-pix' : ''),
    options: {
      hasLaurel: true
    }
  }, React.createElement("span", {
    className: "shield-unit pg_pix__details_banner__shield_unit"
  }, competitionType === 'TipsEM' ? 'Europatips-mästaren' : 'Tips-SM ', ' ', competitionType === CompetitionType.TipsSM ? resolveCompetitionYear(competitionType) : ''), React.createElement("span", {
    className: "shield-value pg_pix__details_banner__shield_value"
  }, "".concat(systemCost, " kr"))) : React.createElement("h3", {
    className: "pg_pix__details_banner__pix_size"
  }, "".concat(systemCost, " kr"))), React.createElement("div", {
    className: "pg_pix__buy_banner"
  }, React.createElement("div", {
    className: "pg_pix__buy_banner__text"
  }, React.createElement(BuyBannerText, null)), React.createElement(PayButton, {
    branding: branding,
    drawNumber: drawNumber,
    isDisabled: disablePixItem,
    payButtonClassNames: "btn btn-default pg_pix__buy_banner__button ".concat(isCompetition ? "pg_pix__buy_banner__button--".concat(competitionType.toLowerCase()) : ''),
    productId: productId,
    rowPrice: rowPrice,
    systemCost: systemCost,
    wallet: wallet
  }), React.createElement("button", {
    className: showDetailsClassNames.join(' '),
    ref: initiator,
    type: "button"
  }, "Visa detaljer"))), showQuickPlay && React.createElement(QuickplayModal, {
    branding: branding,
    competitionBranding: competitionBranding,
    drawNumber: drawNumber,
    hasPortal: true,
    initiator: initiator.current,
    onModalClose: onModalClose,
    productId: productId,
    rowPrice: 1,
    systemCost: systemCost,
    wallet: wallet
  }));
};
setGlobal('svs.components.tipsen.pixItem.PixItem', PixItem);

 })(window);